import { motion } from 'framer-motion';
import { FaFileDownload } from 'react-icons/fa';
import { useLanguage } from '../LanguageContext';
import './AboutIntro.css';

const fadeUp = (delay) => ({
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] } },
});

function AboutIntro() {
  const { t } = useLanguage();

  return (
    <motion.section
      className="about-intro"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      variants={{ hidden: {}, show: {} }}
    >
      <motion.div className="about-photo-frame" variants={fadeUp(0)}>
        <div className="about-photo-ring" />
        <div className="about-photo-placeholder">
          <img src="/Professional%20Headshot%20Image.png" alt="Santhosh Dayakar" className="about-photo-img" />
        </div>
      </motion.div>

      <div className="about-intro-text">
        <motion.span className="about-kicker" variants={fadeUp(0.1)}>
          {t.about.kicker}
        </motion.span>

        <motion.h2 className="about-heading" variants={fadeUp(0.2)}>
          {t.about.heading}
        </motion.h2>

        <motion.p className="about-bio" variants={fadeUp(0.3)}>
          {t.about.bio}
        </motion.p>

        <motion.div className="about-roles" variants={fadeUp(0.4)}>
          {t.about.roles.map((role) => (
            <span key={role} className="about-role-pill glass">
              {role}
            </span>
          ))}
        </motion.div>

        <motion.a
          href="/Santhosh%20Dayakar%20Resume.pdf"
          download
          className="about-resume-btn"
          variants={fadeUp(0.5)}
        >
          <FaFileDownload /> {t.about.resume}
        </motion.a>
      </div>
    </motion.section>
  );
}

export default AboutIntro;
